// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-6508f8fa] .el-card.is-always-shadow {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 0 4px;\n}\n.padding-24[data-v-6508f8fa] {\n  padding: 20px 24px 0;\n}", ""]);
// Exports
module.exports = exports;
